export const cookies = {
  NEWUSER: 'bns.nu',
  BA_PREFS: 'bn.prf'
};
